import axios from 'axios';
import i18next from 'i18next';

import { CONFIG } from '@frontend/config';

const DEFAULT_TIMEOUT = 60000;

export const client = axios.create({
  baseURL: CONFIG.API_URL,
  timeout: DEFAULT_TIMEOUT,
  headers: {
    'Accept-Language': i18next.language,
    'Agency-Id': CONFIG.AGENCY_ID,
  },
  withCredentials: true,
});

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest.iamretry) {
      originalRequest.iamretry = true;

      try {
        await axios({
          method: 'POST',
          url: `${CONFIG.API_URL}auth/refresh-token`,
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            'Agency-Id': CONFIG.AGENCY_ID,
          },
        });

        client(originalRequest);
      } catch (error) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);
